import PropTypes from 'prop-types'
import { P3 } from '@moneymade/moneymade-ui'

import { toNumberWithDecimal, toWithSeparator } from 'utils/getters'
import styles from './TooltipPopup.module.scss'

const TooltipPopup = ({ active, payload, label }) => {
  const { return: returnThisYear = 0, start = 0 } = payload[0]?.payload || {}
  // End of the year. Additional field on tooltip
  const endOfTheYear = toNumberWithDecimal(start + returnThisYear)
  // Payload with additional row
  const fullPayload = [...payload, { name: 'End of the year', value: endOfTheYear, color: '#5056e7' }]
  // Payload modifications
  const tooltipData = fullPayload.map(({ name, value, ...props }) => {
    let newValue = value

    // Trick for 'Investment' to hack the BarChatr
    if (name === 'Investment') newValue = start

    newValue = newValue >= 0 ? `$${newValue}` : `-$${`${newValue}`.replace('-', '')}`

    if (name === 'Fees this year') newValue = `(${newValue})`

    return { name, value: newValue, ...props }
  })

  // Now need to show only Return but code with all calculations are present
  const returnTooltipData = tooltipData.filter(({ name }) => name === 'Return this year')

  return active ? (
    <div className={styles.TooltipPopup}>
      <P3 className={styles.Title} type="heading" weight="bold">{`Year ${label.replace('y', '')}`}</P3>

      <ul className={styles.Payload}>
        {returnTooltipData.map(({ name, value, color }, index) => (
          <li key={index} style={{ color }}>
            <span>{name}:</span>
            <span>{toWithSeparator(value)}</span>
          </li>
        ))}
      </ul>
    </div>
  ) : null
}

TooltipPopup.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string
}

TooltipPopup.defaultProps = {
  active: false,
  payload: [],
  label: ''
}

export default TooltipPopup
